var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveStatsHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 204.3 204.3",
    style: {
      enableBackground: "new 0 0 204.3 204.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2A6DFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.2,0C45.7,0,0,45.7,0,102.2c0,56.5,45.7,102.2,102.2,102.2c56.5,0,102.2-45.7,102.2-102.2 C204.3,45.7,158.6,0,102.2,0z M102.2,188.4c-47.6,0-86.2-38.6-86.2-86.2C16,54.5,54.5,16,102.2,16c47.6,0,86.2,38.6,86.2,86.2 C188.4,149.8,149.8,188.4,102.2,188.4z M174,80.9v30.3c0,4.4-3.6,8-8,8s-8-3.6-8-8v-11.1l-28.9,28.9c-3.1,3.1-8.2,3.1-11.3,0 L80.9,92.2L44,129.1c-3.1,3.1-8.2,3.1-11.3,0c-3.1-3.1-3.1-8.2,0-11.3l42.6-42.6c3.1-3.1,8.2-3.1,11.3,0l36.9,36.9l23.3-23.3h-11.1 c-4.4,0-8-3.6-8-8s3.6-8,8-8H166C170.5,72.9,174,76.6,174,80.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveStatsHover);
export default __webpack_public_path__ + "static/media/live_stats_hover.f9c598e6befc303ca7fe97e1d6c68b5b.svg";
export { ForwardRef as ReactComponent };